import { resizeProperty } from '@/helpers';
import { CodeHighlight } from '@mantine/code-highlight';
import { ActionIcon, Box, Group, Tooltip } from '@mantine/core';
import { IconZoomIn, IconZoomOut } from '@tabler/icons-react';
import { useRef, useState } from 'react';

export function CodeBlock({ item, formValues, containerWidth }) {
  const [fontSize, setFontSize] = useState(formValues.body_font_size);
  const holdTimer = useRef(null);
  const reduceFontSize = () => setFontSize((current) => current - 1);
  const increaseFontSize = () => setFontSize((current) => current + 1);
  const stopHolding = () => {
    if (holdTimer.current) {
      clearInterval(holdTimer.current);
      holdTimer.current = null;
    }
  };

  return (
    <Box pos="relative">
      <Group pos="absolute" style={{ top: '5px', right: '30px', zIndex: 1 }} gap={0}>
        <Tooltip label="Reduce font size">
          <ActionIcon
            variant="subtle"
            aria-label="Settings"
            onClick={reduceFontSize}
            onMouseDown={() => {
              holdTimer.current = setInterval(reduceFontSize, 100); // Adjust the interval as needed
            }}
            onMouseUp={stopHolding}
            onMouseLeave={stopHolding} // Ensures it stops when the mouse leaves
          >
            <IconZoomOut style={{ width: '70%', height: '70%' }} stroke={2} color="#868E96" />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Increase font size">
          <ActionIcon
            variant="subtle"
            aria-label="Settings"
            onClick={increaseFontSize}
            onMouseDown={() => {
              holdTimer.current = setInterval(increaseFontSize, 100); // Adjust the interval as needed
            }}
            onMouseUp={stopHolding}
            onMouseLeave={stopHolding} // Ensures it stops when the mouse leaves
          >
            <IconZoomIn style={{ width: '70%', height: '70%' }} stroke={2} color="#868E96" />
          </ActionIcon>
        </Tooltip>
      </Group>
      <CodeHighlight
        p="md"
        code={item.children
          .filter((child) => child.type === 'code-highlight' || child.type === 'linebreak')
          .map((child) => (child.type === 'linebreak' ? '\n' : child.text))
          .join('')}
        language={item.language}
        withCopyButton
        mb="md"
        styles={{ code: { fontSize: resizeProperty(containerWidth, fontSize) } }}
      />
    </Box>
  );
}
